<template>
  <v-select
    :label="label"
    :loading="loading"
    outlined
    hide-details
    class="mb-3 custom-select"
    :items="items"
    :item-text="itemText"
    item-value="id"
    return-object
    :menu-props="customSelectMenuProps"
  >
    <template #append>
      <arrow-icon class="custom-select-arrow-down-icon" />
    </template>

    <template v-slot:append-item>
      <div v-intersect="handleLoadMoreItems" />
    </template>

    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>

    <template #item="{ item }">
      <v-list-item @click="handleItemsSelect(item)">
        <v-list-item-action>
          <v-checkbox :input-value="isItemSelected(item)" />
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ item[itemText] }}
          </v-list-item-title>
          <star-icon
            v-if="item.isMainLink"
            class="star-icon"
          />
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
import ArrowIcon from '@/assets/svgIcons/arrowDownIcon.svg?inline'
import StarIcon from '@/assets/svgIcons/starOutline.svg?inline'

export default {
  name: 'CustomSelect',
  components: {
    ArrowIcon,
    StarIcon
  },
  props: {
    itemsList: {
      type: Array,
      default: () => ([])
    },
    selectedItems: {
      type: Array,
      default: () => ([])
    },
    label: {
      type: String,
      default: ''
    },
    itemText: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    items() {
      if (!this.itemsList) {
        return []
      }

      return [
        {
          source: this.$t('affiliateProgram.links.selectAll'),
          value: 'selectAll',
        },
        ...this.itemsList
      ]
    },
    customSelectMenuProps() {
      return {
        maxWidth: '300px',
        rounded: 'lg',
        offsetY: true,
        closeOnClick: true,
        contentClass: 'custom-select-menu'
      }
    }
  },
  methods: {
    isItemSelected (item) {
      if (item.value === 'selectAll') {
        return this.selectedItems.length === this.itemsList.length
      }

      return this.selectedItems?.find(i => i.id === item.id)
    },

    handleItemsSelect (item) {
      this.$emit('handleSelected', item)
    },

    handleLoadMoreItems(entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.$emit('loadMoreItems');
      }
    },
  }
}
</script>

<style lang="scss">
.v-application--is-ltr .v-text-field.custom-select .v-input__append-inner {
  padding: 0;
  margin: auto 0 auto 8px;
  cursor: pointer;
}

.custom-select {
  max-width: 270px;
  width: 270px;
  height: max-content;

  &.v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 40px;
    height: 40px;
    cursor: auto;
  }

  &.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
    padding: 0 16px;
  }

  .v-input__append-inner svg {
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
    margin: auto 0;
    padding: 0;
  }

  &.v-select--is-menu-active {
    .v-input__append-inner svg {
      transform: rotate(180deg);
    }
  }

  .v-input__slot {
    background: var(--v-input-background-default-base);
  }

  &.v-text-field--outlined fieldset,
  &.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state):not(.v-input--is-disabled) > .v-input__control > .v-input__slot:hover fieldset {
    border-radius: 8px;
    border: 1px solid var(--v-input-border-default-base);
    color: transparent;
  }

  &.v-text-field--outlined.v-select--is-menu-active:not(.v-input--has-state):not(.v-input--is-disabled) > .v-input__control > .v-input__slot fieldset {
    border: 1px solid var(--v-input-border-focused-base);
  }

  .custom-select-arrow-down-icon {
    width: 20px;
    height: 20px;
    color: var(--v-icon-tertiary-base);
  }
}
.custom-select-menu {
  .v-list-item__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
  }

  .v-list-item {
    height: 36px;
    min-height: unset;
    padding: 6px 16px;


    .star-icon {
      width: 20px;
      height: 20px;
      color: var(--v-foundation-brand-700-base);
      margin-left: 10px;
      flex: unset;
    }

    .v-list-item__title {
      flex: unset;
      margin-bottom: 0;
      color: var(--v-input-foreground-typed-base);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }

    .v-list-item__action {
      margin: 0 10px 0 0;
    }

    .v-input--selection-controls__input i {
      color: var(--v-controls-background-inactive-default-base);
    }
  }

 .v-list-item:first-child {
   border-bottom: 1px solid var(--v-border-primary-base);
   .v-list-item__title {
     color: var(--v-text-secondary-base);
   }
 }

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>

